import { FC, ReactNode } from 'react';

export type StackAlign = 'start' | 'center' | 'end' | 'stretch';
export type StackGap = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export type StackProps = {
  children: ReactNode;
  direction?: 'column' | 'row';
  gap?: StackGap;
  align?: StackAlign;
  className?: string;
};

/** A flex container on the shared spacing scale. Row stacks centre by default. */
const Stack: FC<StackProps> = ({ children, direction = 'column', gap, align, className }) => (
  <div
    className={['ui-stack', 'ui-stack--' + direction, gap && 'ui-stack--gap-' + gap, align && 'ui-stack--align-' + align, className]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </div>
);

export default Stack;
